import React from 'react';
import { useLang } from '../../context/LangContext';

const GOLD = '#c9a23a';

export default function ProgressBar({ completed, total }) {
  const { t } = useLang();
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 7, fontSize: 12 }}>
        <span style={{ color: GOLD, fontWeight: 700 }}>{t.learning?.progress}</span>
        <span style={{ color: '#7a6040' }}>{completed} / {total}</span>
      </div>
      <div style={{ background: 'rgba(201,162,58,0.2)', borderRadius: 4, height: 6, overflow: 'hidden' }}>
        <div style={{
          height: '100%',
          width: `${pct}%`,
          background: `linear-gradient(90deg, ${GOLD}, #e8b84b)`,
          borderRadius: 4,
          transition: 'width 0.4s ease',
        }} />
      </div>
      <div style={{ textAlign: 'center', marginTop: 5, fontSize: 11, color: '#a08060' }}>
        {pct}%
      </div>
    </div>
  );
}
